import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable } from 'rxjs';
import { TaskResult } from '../../models/client-models';
import { TaskResultGeneric } from '../../models/task-result-generic';
import { VisumCheck, VisumListItem } from '../../models/client-models';

const VISUM_ENDPOINT = 'visum';

/**
 * Access visum controller form backend.
 */
@Injectable({
  providedIn: 'root',
})
export class VisumBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get visum information for a given Date.
   *
   * @param personID
   * @param date
   */
  getVisumInfoForDay(personID: number, date: string): Observable<VisumCheck> {
    return this.http.post<VisumCheck>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT,
      {
        PersonID: personID,
        Date: date,
      }
    );
  }

  getCurrenVisum(personID: number): Observable<VisumListItem> {
    return this.http.get<VisumListItem>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT + '?PersonID=' + personID
    );
  }

  createCurrenVisum(
    personID: number,
    date: string,
    admiaUserID: number
  ): Observable<TaskResultGeneric<VisumListItem>> {
    return this.http.post<TaskResultGeneric<VisumListItem>>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT + '/create',
      {
        IDPerson: personID,
        VisumDate: date,
        IDAdmiaUser: admiaUserID,
      }
    );
  }

  /**
   * Get visum information for a given Date.
   *
   * @param personID
   * @param date
   * @param chronoUserID
   */
  getVisumInfoForDayChronoUser(
    personID: number,
    date: string,
    chronoUserID: number
  ): Observable<VisumCheck> {
    return this.http.post<VisumCheck>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT + '/chronoUser',
      {
        ChronoUserID: chronoUserID,
        PersonID: personID,
        Date: date,
      }
    );
  }

  /**
   * Remove visum for given person and date.
   *
   * @param personID
   * @param date
   */
  removeVisum(personID: number, date: string): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT + '/remove',
      {
        PersonID: personID,
        Date: date,
      }
    );
  }

  /**
   * Remove visum as chrono user for given person and date.
   *
   * @param chronoUserID
   * @param personID
   * @param date
   */
  removeVisumChronoUser(
    chronoUserID: number,
    personID: number,
    date: string
  ): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + VISUM_ENDPOINT + '/chronoUser/remove',
      {
        ChronoUserID: chronoUserID,
        PersonID: personID,
        Date: date,
      }
    );
  }
}
